import {
  ActivityEventRow,
  ActivityQuote,
  EventIconCircle,
  UserName,
} from "./ActivityEventRow";

import { RichTextDisplay, Text } from "@/components";

import { useGetUser } from "@/hooks/queries/useGetUser";
import { activityTypography } from "@/lib/constants";
import { tiptap } from "@/lib/tiptap";
import { cn } from "@/lib/utils";
import type { InternalCandidacyComment } from "@/types";

const jsonToHtml = tiptap.jsonToHtmlFn();

export const CommentEvent = ({
  candidateFullName,
  comment,
  currentUserId,
}: {
  candidateFullName: string;
  comment: InternalCandidacyComment;
  currentUserId: number;
}) => {
  /* Database CRUD Operations */
  // Read
  const { data: user } = useGetUser({ userId: comment.userId });

  /* Render */
  const render = () => {
    return (
      <ActivityEventRow
        createdAt={comment.createdAt}
        icon={
          <EventIconCircle className="bg-slate-700">
            <Text className="text-[10px] font-medium text-white">
              {user ? `${user.firstName[0]}${user.lastName[0]}` : "?"}
            </Text>
          </EventIconCircle>
        }
        quote={
          <ActivityQuote>
            <Text
              className={cn("whitespace-pre-line", activityTypography.quote)}
              variant="secondary"
            >
              <RichTextDisplay richText={jsonToHtml(comment.contentJson)} />
            </Text>
          </ActivityQuote>
        }
      >
        <UserName currentUserId={currentUserId} user={user} /> left a private
        comment on{" "}
        <span className={activityTypography.emphasis}>{candidateFullName}</span>
      </ActivityEventRow>
    );
  };

  return render();
};
